import moment from 'moment';
import { EmailApiPlan } from 'src/state/types/emailApiPlan';
import { MarketingCampaignsPlan } from 'src/state/types/marketingCampaignsPlan';
import {
  isEiEndOfTrial,
  isMcEndOfTrial,
  isEiOnTrial,
  isMcOnTrial,
  isEiOnFree,
  isMcOnFree,
} from 'src/helpers/offerings/trials';
import { OfferingDto } from 'src/state/dtos';

export const SG_DISCOUNT_FREE_UPGRADE_50_PERCENT_PREFIX =
  'sg.discount.free100-upgrade-50percent.v1';

export const getWhenTrialEnded = (
  currentPlan: EmailApiPlan | MarketingCampaignsPlan
): string | null => {
  const isOnEndOfTrial =
    isEiEndOfTrial(currentPlan as EmailApiPlan) ||
    isMcEndOfTrial(currentPlan as MarketingCampaignsPlan);

  if (!isOnEndOfTrial) {
    return null;
  }

  return currentPlan.startDate;
};

export const getWhenFreeTransitionsToEndOfTrial = (
  currentPlan: EmailApiPlan | MarketingCampaignsPlan,
  futurePlan?: EmailApiPlan | MarketingCampaignsPlan
): string | null => {
  const isOnAnyFree =
    isEiOnFree(currentPlan as EmailApiPlan) ||
    isMcOnFree(currentPlan as MarketingCampaignsPlan);
  // Make sure they're on a free plan currently
  if (!isOnAnyFree) {
    return null;
  }

  // Trial isn't ending or has already ended
  if (!futurePlan) {
    return null;
  }

  const isMovingToEndOfTrial =
    isEiEndOfTrial(futurePlan as EmailApiPlan) ||
    isMcEndOfTrial(futurePlan as MarketingCampaignsPlan);
  if (!isMovingToEndOfTrial) {
    return null;
  }

  return futurePlan.startDate ?? null;
};

export const getWhenTrialTransitionsToEndOfTrial = (
  currentPlan: EmailApiPlan | MarketingCampaignsPlan,
  futurePlan?: EmailApiPlan | MarketingCampaignsPlan
): string | null => {
  const isOnAnyTrial =
    isEiOnTrial(currentPlan as EmailApiPlan) ||
    isMcOnTrial(currentPlan as MarketingCampaignsPlan);
  // Make sure they're on a trial plan currently
  if (!isOnAnyTrial) {
    return null;
  }

  // Trial isn't ending or has already ended
  if (!futurePlan) {
    return null;
  }

  const isMovingToEndOfTrial =
    isEiEndOfTrial(futurePlan as EmailApiPlan) ||
    isMcEndOfTrial(futurePlan as MarketingCampaignsPlan);
  if (!isMovingToEndOfTrial) {
    return null;
  }

  return futurePlan.startDate ?? null;
};

export const hasDiscountFree100Upgrade50Percent = (
  discounts: OfferingDto[]
): boolean => {
  return discounts.some((discount) =>
    discount.name.startsWith(SG_DISCOUNT_FREE_UPGRADE_50_PERCENT_PREFIX)
  );
};

export const formatTrialEndDate = (endOfTrialDate: string) => {
  return moment.utc(endOfTrialDate).format('MMMM Do, YYYY');
};
